import { lazy } from 'react';
import Loadable from 'app/components/Loadable';

// Lazy loading with Loadable for each component
const NotFound = Loadable(lazy(() => import('./NotFound')));
const ForgotPassword = Loadable(lazy(() => import('./ForgotPassword')));
const Login = Loadable(lazy(() => import('./Login')));
const SetPassword = Loadable(lazy(() => import('./SetPassword')));
const FirebaseRegister = Loadable(lazy(() => import('./Register')));
const ResetPassword = Loadable(lazy(() => import('./ResetPassword')));
const DeviceVerify = Loadable(lazy(() => import('./DeviceVerify')));
const VerifyEmail = Loadable(lazy(() => import('./VerifyEmail')));
const EmailVerified = Loadable(lazy(() => import('./EmailVerified')));

// Updated sessionRoutes array with 'element' instead of 'component'
const sessionRoutes = [
    {
        path: '/session/signin',
        element: <Login />,
    },
    {
        path: '/session/forgot-password',
        element: <ForgotPassword />,
    },
    {
        path: '/session/set-password',
        element: <SetPassword />,
    },
    {
        path: '/session/404',
        element: <NotFound />,
    },
    {
        path: '/session/signup',
        element: <FirebaseRegister />,
    },
    {
        path: '/session/verify-email',
        element: <VerifyEmail />,
    },
    {
        path: '/session/email-verified',
        element: <EmailVerified />,
    },
    {
        path: '/session/reset-password',
        element: <ResetPassword />
    },
    {
        path: '/device',
        element: <DeviceVerify />,
    },
];

export default sessionRoutes;
